export const phonePattern = /(^(\+49|49|0049|0[1-9])[0-9\s]+$)/i;
export const emailPattern = /^\s*[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\s*$/i;
export const namePattern = /^.{0,255}$/i;
export const passwordPattern =
  /(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W|_/])[A-Za-z\d\W|_/]{8,}|(?!.*\s)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{14,}$/i; // min 8 chars , Uppercase , Lowercase , Number and special char OR min 14 chars , Uppercase , Lowercase and Number
export const streetPattern = /^.{0,255}$/i;
export const houseNumberPattern = /^$|^\d+(.{0,8})$/i; // empty or starts with int of any length, which can be followed by up to 8 chars except linebreaks
export const zipCodePattern = /^$|^.\d{4}$/i; // exactly 5 int
export const cityPattern = /^.{0,32}$/i;
export const insuranceNumberPattern = /^$|^([a-zA-Z0-9]{10}|[a-zA-Z0-9]{20})$/i; // empty || 10 chars || 20 chars (letters + numbers)
